import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from "./FlightSummary.scss";
import SelectedFlight from '../../Payment/SelectedFlight/SelectedFlight';
import PassengerSummary from '../../Payment/PassengerSummary/PassengerSummary';
import ButtonProceed from '../../UI/Button/ButtonProceed/ButtonProceed';

import CheckBox from '../../UI/CommonCheckBox/CommonCheckBox';
import Button from '../../UI/Button/Button';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import AnimakitExpander from "animakit-expander";
import * as uiActions from '../../../store/actions/index';
import * as farePriceActions from '../../../store/actions/index';
import * as paymentActions from '../../../store/actions/index';
import closeIcon from '../../../assets/images/close-icon.svg';
import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import Media from 'react-media';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class summaryExtended extends Component {

  oneWayProceedHandler = (addonAmount) => {
    if (this.props.location.pathname.indexOf("details") !== -1) {
      this.props.history.push({
        pathname: "/reviews/addons",
        search: this.props.location.search
      })
    } else {
      if(this.props.isHff) {
          console.log("Hff is true");
      } else {
        this.props.payButtonHandler(Math.round(parseFloat(this.props.fareDetailsOneWay.revisedFareDetails.tf, 10) + parseFloat(this.props.markupAmount, 10) + addonAmount))
      }
    }
  }

  roundTripProceedHandler = (addonAmount) => {
    if (this.props.location.pathname.indexOf("details") !== -1) {
      this.props.history.push({
        pathname: "/reviews/addons",
        search: this.props.location.search
      })
    } else {
      this.props.payButtonHandler(Math.round(parseFloat(this.props.fareDetailsOneWay.revisedFareDetails.tf, 10) + parseFloat(this.props.fareDetailsRoundTrip.revisedFareDetails.tf, 10) + parseFloat(this.props.markupAmount, 10) + addonAmount))
    }
  }

  render() {
  let addonList = [];
  let totalAmount = 0;

  let bookingDetailParams = [];
  bookingDetailParams.push('superPnr=' + this.props.superPnr);
  bookingDetailParams.push('uuid=' + this.props.pid);
  bookingDetailParams.push('client=DESKTOP');
  bookingDetailParams.push('lob=FLIGHT');
  bookingDetailParams.push('unique=rkd');

  const routePath = this.props.location.pathname;
  const isPathPay = routePath.indexOf("pay") !== -1;
  const isPathDetails = routePath.indexOf("details") !== -1;

  if(this.props.addonList) {
    let tempAddonList = [];
    let addonListCopy = JSON.parse(JSON.stringify(this.props.addonList));
    for(let i=0; i < addonListCopy.length; i++) {
      let elementFound = false;
      for(let j=0; j < tempAddonList.length; j++) {
        if(addonListCopy[i].addonLabel === tempAddonList[j].addonLabel) {
          tempAddonList[j].amount += addonListCopy[i].amount;
          elementFound = true;
        }
      }
      if(!elementFound) {
        tempAddonList.push(addonListCopy[i]);
      }
    }

    tempAddonList.map((addon, index) => {
      totalAmount += addon.amount;
      return addonList.push(
         addon.amount !== 0 ? <li className={classes.AddonsListItem} key={index}>
                        <div className={`u-flex`}> 
                          <div>{addon.addonLabel} <span className={`u-cursorPointer`} onClick={() => {
                              this.props.onRemoveAddonFromFarePrice(addon.addonLabel)
                          }}><FontAwesomeIcon icon="times" color="#666" size="sm" /></span></div>
                        </div>
                        <div className={`u-fontWeightMedium`}>
                          &#8377;{addon.amount}
                        </div>
                      </li> : null
      );
    });
  }

  if (this.props.fareDetailsOneWay && !this.props.fareDetailsRoundTrip) {
    let flightTotalPrice = 0;
    let adultQTO = 0;
    let childQTO = 0;
    let infantQTO = 0;
    const fareDetailsO = this.props.fareDetailsOneWay;

    let feeSurcharge = 0;

    if (fareDetailsO.ADT) {
      const aFareDetails = fareDetailsO.ADT;
      adultQTO = parseInt(aFareDetails.qt, 10);
    }

    if (fareDetailsO.CHD) {
      const cFareDetails = fareDetailsO.CHD;
      childQTO = parseInt(cFareDetails.qt, 10);
    }

    if (fareDetailsO.INF) {
      const iFareDetails = fareDetailsO.INF;
      infantQTO = parseInt(iFareDetails.qt, 10);
    }
    feeSurcharge = Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10)) + Math.round(parseFloat(fareDetailsO.revisedFareDetails.UDF, 10)) + Math.round(parseFloat(fareDetailsO.revisedFareDetails.GAST, 10)) + Math.round(parseFloat(fareDetailsO.revisedFareDetails.fsc, 10)) + Math.round(parseFloat(fareDetailsO.revisedFareDetails.OC, 10));

    flightTotalPrice = Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf, 10));

    return (
      <div className={classes.Container}>
        <div style={{display: isPathPay ? 'none' : 'flex'}} className={`pl-6 pr-6 align-items-center u-flex justify-content-between u-backgroundColorWhite u-relative u-tabPortShow`}>
          <h2 className={`${classes.HeadingMain} u-fontSize16 u-textColorDark u-fontWeightMedium`}>Fare Details</h2>
          {
            this.props.mobileFareBreakup ? <div className={classes.CloseImage} onClick={() => this.props.onToggleMobileFareBreakup()}>
              <img src={closeIcon} alt='Close'/>
            </div> : null
          }
        </div>
        <div style={{justifyContent: isPathPay ? 'flex-start' : 'space-between'}} className={classes.ContainerInner}>
          {
            isPathPay ? <React.Fragment>
              <div className="mb-3">
                <HeadingH2 size={16} weight="Medium" color="Dark">Selected Flight</HeadingH2>
              </div>
              <div className="mb-3"><SelectedFlight type="onward" /></div>
              <div className="mb-auto"><PassengerSummary /></div>
            </React.Fragment> : null
          }
          <div style={{
            transform: 'translateY(0)',
            transition: 'all .4s ease-in-out',
            zIndex: '9',
            position: 'relative',
            maxHeight: '480px'
            }}>
            {isPathPay ? null : (
              <div className="u-flex justify-content-between align-items-center mb-4">
                <div className={`u-tabPortHide`}>
                  <HeadingH3 size={16} weight="Medium" color="Dark">Fare Details</HeadingH3>
                </div>
                <div className="u-flex align-items-center justify-content-between u-tabPort-width100Percent">
                  <div className={`u-flex align-items-center mr-2`}>
                    <div className={`mr-1`}>
                      <CheckBox checkboxtype='square' onChange={this.props.inputChangeHandler} name='isAgentProfit' checked={this.props.isAgentProfit} />
                    </div>
                    <span className={`u-tabPortShow`}>Show Profit</span>
                  </div>
                  <div>
                    {
                      this.props.isSetMarkup ? <Button theme='OutlinePrimary' type="Markup" onClick={this.props.onToggleMarkup}>Cancel</Button> : <Button theme='OutlinePrimary' type='Markup' onClick={this.props.onToggleMarkup}>Set Markup</Button>
                    }
                  </div>                    
                </div>
            </div>
            )}
            {
              !this.props.isSetMarkup ? <React.Fragment>
              {isPathPay ? (
                <React.Fragment>
                  {
                    this.props.amountDetails !== null ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                      <span>Payment Surcharge</span> 
                      <span> &#8377;{Math.round(parseFloat(this.props.amountDetails.surchargeWithGST,10)).toLocaleString() }</span>
                    </p> : null
                  }
                  {
                    this.props.amountDetails !== null ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                      <span>Total Price</span> 
                      <span>&#8377;{Math.round(parseFloat(this.props.amountDetails.beforeSurchargeAmount, 10)).toLocaleString()}</span>
                    </p> : null
                  }
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                    <span>Base Fare <span className={`u-textColorPrimary u-fontWeightMedium`}>({adultQTO + childQTO + infantQTO > 1 ? adultQTO + childQTO + infantQTO + ' Travellers' : adultQTO + childQTO + infantQTO + ' Traveller'})</span></span> 
                    <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.bf, 10)).toLocaleString()}</span>
                  </p>
                  <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                    <span>Fee and surcharges
                      <span className={`u-cursorPointer ml-1 u-inlineBlock u-transition--transform200Spring`} onClick={() => this.props.onToggleFareBreakups(1)} style={{transform: this.props.breakupExpanded === 1 ? 'rotate(-180deg)' : 'rotate(0deg)'}}>
                        <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
                      </span>
                    </span> 
                    <span>&#8377;{(feeSurcharge + Math.round(parseFloat(this.props.markupAmount, 10))).toLocaleString()}</span>
                  </p>
                  <AnimakitExpander 
                    expanded={this.props.breakupExpanded === 1} 
                    duration={400}
                    align="top">
                    <div className={classes.Inner}>
                      {fareDetailsO.revisedFareDetails.PSF && (Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10)) > 0) ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>Passenger Service Fee <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10)).toLocaleString()}</span></p> : null}
                      {fareDetailsO.revisedFareDetails.UDF && (Math.round(parseFloat(fareDetailsO.revisedFareDetails.UDF, 10)) > 0) ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>User Development Fee <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.UDF, 10)).toLocaleString()}</span></p> : null}
                      {fareDetailsO.revisedFareDetails.GAST && (Math.round(parseFloat(fareDetailsO.revisedFareDetails.GAST, 10)) > 0) ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>GST  <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.GAST, 10)).toLocaleString()}</span></p> : null}
                      {fareDetailsO.revisedFareDetails.fsc && (Math.round(parseFloat(fareDetailsO.revisedFareDetails.fsc, 10)) > 0) ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>Airline Fuel Surcharges <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.fsc, 10)).toLocaleString()}</span></p> : null}
                      {fareDetailsO.revisedFareDetails.OC && (Math.round(parseFloat(fareDetailsO.revisedFareDetails.OC, 10)) > 0) ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>Other Charges <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.OC, 10) + parseFloat(this.props.markupAmount, 10)).toLocaleString()}</span></p> : null}
                    </div>
                  </AnimakitExpander>
                  <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                    <span>Booking Fee</span> 
                    <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.wholeSalerFee, 10)).toLocaleString()}</span>
                  </p>
                  {Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfIgst, 10)) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                    <span>iGST</span> 
                    <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfIgst, 10)).toLocaleString()}</span>
                  </p> : null}
                  {Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfCgst, 10)) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                    <span>cGST</span> 
                    <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfCgst, 10)).toLocaleString()}</span>
                  </p> : null}
                  {Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfSgst, 10)) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                    <span>sGST</span> 
                    <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfSgst, 10)).toLocaleString()}</span>
                  </p> : null}
                  {totalAmount > 0 ? (
                    <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                      <span>Add-Ons  
                        <span className={`u-cursorPointer ml-1 u-inlineBlock u-transition--transform200Spring`} onClick={() => this.props.onToggleFareBreakups(2)} style={{transform: this.props.breakupExpanded === 2 ? 'rotate(-180deg)' : 'rotate(0deg)'}}>
                          <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
                        </span>
                      </span>
                      <span>+ &#8377;{totalAmount.toLocaleString()}</span>
                    </p>
                  ) : null}
                  <AnimakitExpander 
                  expanded={this.props.breakupExpanded === 2}
                  duration={400}
                  align="top">
                    <div className={classes.Addons}>
                      <ul>
                        {addonList}
                      </ul>
                    </div>
                  </AnimakitExpander>
                  </React.Fragment>
                )} 
                <div className={classes.CustomDivider} />
              {this.props.isAgentProfit ? (
                <div style={{display: isPathPay ? 'none' : 'block'}} className={classes.WhiteBackground}>
                  <div>
                    <p className={`u-flex justify-content-between align-items-center u-fontSize16 u-textColorDark mb-2`}>
                      <span className="u-fontSize16 u-fontWeightMedium">Total Fare</span>
                      <span className="u-fontSize16 u-fontWeightMedium">&#8377;{Math.round(parseFloat(flightTotalPrice) + parseFloat(this.props.markupAmount, 10) + totalAmount).toLocaleString()}</span>
                    </p>
                    <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-2`}>
                      <span>Agency Commision</span>
                      <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.commision, 10) + parseFloat(this.props.markupAmount, 10)).toLocaleString()}</span>
                    </p>
                    <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-2`}>
                      <span>TDS</span>
                      <span>&#8377;{Math.round(parseFloat(fareDetailsO.revisedFareDetails.tds, 10)).toLocaleString()}</span>
                    </p>
                  </div>
                </div>
              ) : null}
              </React.Fragment> : <React.Fragment>
              <div className={`mb-5 mt-8`}>
                  <InputMaterial 
                      type='number'
                      label='Set Markup Amount' 
                      alignment='left' 
                      maxLength="10" 
                      value={this.props.markupInput} 
                      onChange={this.props.inputChangeHandler} 
                      name='markupInput' />
              </div>
              <div className="mb-3">
                <ButtonProceed 
                        clicked={this.props.onSetMarkup}
                        isactive={ parseFloat(this.props.markupInput, 10) > 0 }>
                        SET MARKUP NOW
                </ButtonProceed> 
              </div>
              <Button onClick={this.props.resetClicked} theme="OutlinePrimary" width="Block" type="MarkupLarge">RESET</Button>
            </React.Fragment>
            }
          </div>
          {
            !this.props.isSetMarkup ? <div>
            <div className={`u-flex justify-content-between align-items-center mb-4`}>
              <HeadingH3 size={26} weight="Medium" color="Dark">{this.props.isAgentProfit ? 'Net Fare' : 'Total Fare'}</HeadingH3>
              {
                isPathPay ? 
                  <HeadingH3 size={26} weight="Medium" color="Dark">&#8377;{Math.round(parseFloat(this.props.totalPrice, 10)).toLocaleString()}</HeadingH3> : 
                  <HeadingH3 size={26} weight="Medium" color="Dark">&#8377;{this.props.isAgentProfit ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.nf) + totalAmount).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf) + parseFloat(this.props.markupAmount) + totalAmount).toLocaleString()}</HeadingH3>
              }
            </div>
            <div style={{display: isPathPay ? 'none' : 'block'}}>
              <Media query="(min-width: 899px)">
                  {matches => 
                    matches ? <div className={classes.ContainerTwo}>
                                <ButtonProceed isactive={ isPathDetails ? this.props.isContinueButtonActive : this.props.isPaymentButtonActive} clicked={() => this.oneWayProceedHandler(totalAmount)}>{isPathDetails ? 'Continue' : this.props.isHff ? 'Hold' : 'Proceed To Pay'}</ButtonProceed>
                              </div> : null
                  }
              </Media>
            </div>
          </div> : null
          }
        </div>
      </div>
    );
  } else if (this.props.fareDetailsOneWay && this.props.fareDetailsRoundTrip) {
    const params = new URLSearchParams(this.props.location.search);

    let flightTotalPrice = 0;
    let adultQTO = 0;
    let childQTO = 0;
    let infantQTO = 0;
    const fareDetailsO = this.props.fareDetailsOneWay;
    const fareDetailsR = this.props.fareDetailsRoundTrip;

    let feeSurcharge = 0;

    if (fareDetailsO.ADT) {
      const aFareDetails = fareDetailsO.ADT;
      adultQTO = parseInt(aFareDetails.qt, 10);
    }

    if (fareDetailsO.CHD) {
      const cFareDetails = fareDetailsO.CHD;
      childQTO = parseInt(cFareDetails.qt, 10);
    }

    if (fareDetailsO.INF) {
      const iFareDetails = fareDetailsO.INF;
      infantQTO = parseInt(iFareDetails.qt, 10);
    }


    if(params.get("isInt") === "true") {
      feeSurcharge = Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10) + parseFloat(fareDetailsO.revisedFareDetails.UDF, 10) + parseFloat(fareDetailsO.revisedFareDetails.GAST, 10) + parseFloat(fareDetailsO.revisedFareDetails.fsc, 10) + parseFloat(fareDetailsO.revisedFareDetails.OC, 10)) + Math.round(parseFloat(this.props.markupAmount, 10));
      flightTotalPrice = Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf, 10));
    } else {
      feeSurcharge = Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10) + parseFloat(fareDetailsO.revisedFareDetails.UDF, 10) + parseFloat(fareDetailsO.revisedFareDetails.GAST, 10) + parseFloat(fareDetailsO.revisedFareDetails.fsc, 10) + parseFloat(fareDetailsO.revisedFareDetails.OC, 10) + parseFloat(fareDetailsR.revisedFareDetails.OC, 10) + parseFloat(fareDetailsR.revisedFareDetails.fsc, 10) + parseFloat(fareDetailsR.revisedFareDetails.UDF, 10) + parseFloat(fareDetailsR.revisedFareDetails.GAST, 10) + parseFloat(fareDetailsR.revisedFareDetails.PSF, 10)) + Math.round(parseFloat(this.props.markupAmount, 10));
      flightTotalPrice = Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf, 10) + parseFloat(fareDetailsR.revisedFareDetails.tf, 10));
    }

    return (
      <div className={classes.Container}>
        <div style={{display: isPathPay ? 'none' : 'flex'}} className={`pl-6 pr-6 align-items-center u-flex justify-content-between u-backgroundColorWhite u-relative u-tabPortShow`}>
          <h2 className={`${classes.HeadingMain} u-fontSize16 u-textColorDark u-fontWeightMedium`}>Fare Details</h2>
          {
            this.props.mobileFareBreakup ? <div className={classes.CloseImage} onClick={() => this.props.onToggleMobileFareBreakup()}>
              <img src={closeIcon} alt='Close'/>
            </div> : null
          }
        </div>
        <div style={{justifyContent: isPathPay ? 'flex-start' : 'space-between'}} className={classes.ContainerInner}>
        {isPathPay ? (<React.Fragment>
            <div className="mb-3">
              <HeadingH2 size={16} weight="Medium" color="Dark">Selected Flights</HeadingH2>
            </div>
            <div className="mb-3"><SelectedFlight type="onward" /></div>
            <div className="mb-3"><SelectedFlight type="return" /></div>
            <div className="mb-auto"><PassengerSummary /></div>
          </React.Fragment>) : null}
        {isPathPay ? (
          <React.Fragment>
            {
              this.props.amountDetails !== null ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
              <span>Payment Surcharge</span> 
              <span> &#8377;{Math.round(parseFloat(this.props.amountDetails.surchargeWithGST, 10)).toLocaleString() }</span>
            </p> : null
            }
            {
              this.props.amountDetails !== null ? <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                <span>Total Price</span> 
                <span>&#8377;{Math.round(parseFloat(this.props.amountDetails.beforeSurchargeAmount, 10)).toLocaleString()}</span>
              </p> : null
            }
          </React.Fragment>
        ) : (
          <div style={{
            transform: 'translateY(0)',
            transition: 'all .4s ease-in-out',
            zIndex: '9',
            position: 'relative',
            maxHeight: '480px'
          }}> 
            <div className="u-flex justify-content-between align-items-center mb-4">
              <div className={`u-tabPortHide`}>
                <HeadingH3 size={16} weight="Medium" color="Dark">Fare Details</HeadingH3>
              </div>
              <div className="u-flex align-items-center justify-content-between u-tabPort-width100Percent">
                <div className={`u-flex align-items-center mr-2`}>
                  <div className={`mr-1`}>
                    <CheckBox checkboxtype='square' onChange={this.props.inputChangeHandler} name='isAgentProfit' checked={this.props.isAgentProfit} />
                  </div>
                  <span className={`u-tabPortShow`}>Show Profit</span>
                </div>
                <div>
                  { this.props.isSetMarkup ? <Button theme='OutlinePrimary' type="Markup" onClick={this.props.onToggleMarkup}>Cancel</Button> : <Button theme='OutlinePrimary' type='Markup' onClick={this.props.onToggleMarkup}>Set Markup</Button> }
                </div>
              </div>
            </div>
            {
              !this.props.isSetMarkup ? <React.Fragment> 
                <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
              <span>Base Fare <span className={`u-textColorPrimary u-fontWeightMedium`}>({adultQTO + childQTO + infantQTO > 1 ? adultQTO + childQTO + infantQTO + ' Travellers' : adultQTO + childQTO + infantQTO + 'Traveller'})</span></span> 
              <span>&#8377; {params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.bf, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.bf, 10) + Math.round(parseFloat(fareDetailsR.revisedFareDetails.bf, 10))).toLocaleString() }</span>
            </p>
            <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
              <span>Fee and surcharges
                <span className={`u-cursorPointer ml-1 u-inlineBlock u-transition--transform200Spring`} onClick={() => this.props.onToggleFareBreakups(1)} style={{transform: this.props.breakupExpanded === 1 ? 'rotate(-180deg)' : 'rotate(0deg)'}}>
                  <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
                </span>
              </span>
              <span>&#8377; {feeSurcharge.toLocaleString()}</span>
            </p>
            <AnimakitExpander 
              expanded={this.props.breakupExpanded === 1} 
              duration={400}
              align="top">
              <div className={classes.Inner}>
                  {Math.round(fareDetailsO.revisedFareDetails.PSF) > 0 || Math.round(fareDetailsR.revisedFareDetails.PSF) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>Passenger Service Fee <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.PSF, 10) + parseFloat(fareDetailsR.revisedFareDetails.PSF, 10)).toLocaleString()}</span></p> : null}
                  {Math.round(fareDetailsO.revisedFareDetails.UDF) > 0 || Math.round(fareDetailsR.revisedFareDetails.UDF) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>User Development Fee <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.UDF, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.UDF, 10) + parseFloat(fareDetailsR.revisedFareDetails.UDF, 10)).toLocaleString()}</span></p> : null}
                  {Math.round(fareDetailsO.revisedFareDetails.GAST) > 0 || Math.round(fareDetailsR.revisedFareDetails.GAST) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>GST  <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.GAST, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.GAST, 10) + parseFloat(fareDetailsR.revisedFareDetails.GAST, 10)).toLocaleString() }</span></p> : null}
                  {Math.round(fareDetailsO.revisedFareDetails.fsc) > 0 || Math.round(fareDetailsR.revisedFareDetails.fsc) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>Airline Fuel Surcharges <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.fsc, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.fsc, 10) + parseFloat(fareDetailsR.revisedFareDetails.fsc, 10)).toLocaleString()}</span></p> : null}
                  {Math.round(fareDetailsO.revisedFareDetails.OC) > 0 || Math.round(fareDetailsR.revisedFareDetails.OC) > 0 ? <p className={`u-flex justify-content-between align-items-center u-fontWeightRegular u-textColorNormal`}>Other Charges <span className={`u-textColorDark u-fontWeightMedium u-fontSize13`}>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.OC, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.OC, 10) + parseFloat(fareDetailsR.revisedFareDetails.OC, 10) + parseFloat(this.props.markupAmount, 10)).toLocaleString()}</span></p> : null}
              </div>
            </AnimakitExpander>
              <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                <span>Booking Fee</span> 
                <span>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.wholeSalerFee, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.wholeSalerFee, 10) + parseFloat(fareDetailsR.revisedFareDetails.wholeSalerFee, 10)).toLocaleString()}</span>
              </p>
              <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                <span>iGST</span> 
                <span>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfIgst, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfIgst, 10) + parseFloat(fareDetailsR.revisedFareDetails.wsfIgst, 10)).toLocaleString()}</span>
              </p>
              <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                <span>cGST</span> 
                <span>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfCgst, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfCgst, 10) + parseFloat(fareDetailsR.revisedFareDetails.wsfCgst, 10)).toLocaleString()}</span>
              </p>
              <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                <span>sGST</span> 
                <span>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfSgst, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.wsfSgst, 10) + parseFloat(fareDetailsR.revisedFareDetails.wsfSgst, 10)).toLocaleString()}</span>
              </p>
              {totalAmount ? (
                <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3`}>
                  <span>Add-Ons 
                    <span className={`u-cursorPointer ml-1 u-inlineBlock u-transition--transform200Spring`} onClick={() => this.props.onToggleFareBreakups(2)} style={{transform: this.props.breakupExpanded === 2 ? 'rotate(-180deg)' : 'rotate(0deg)'}}>
                      <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
                    </span> 
                  </span>
                  <span>+ &#8377;{totalAmount.toLocaleString()}</span>
                </p>
              ) : null}
              { this.props.breakupExpanded === 2 ? <div className={classes.Divider}></div> : null }
              <AnimakitExpander 
              expanded={this.props.breakupExpanded === 2}
              duration={400}
              align="top">
                <div className={classes.Addons}>
                  <ul className={`pt-1 pb-1`}>
                    {addonList}
                  </ul>
                </div>
              </AnimakitExpander>
              <div className={classes.CustomDivider} />
              {this.props.isAgentProfit ? (
                <div style={{display: isPathPay ? 'none' : 'block'}} className={classes.WhiteBackground}>
                  <div>
                    <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-2`}>
                      <span>Total Fare</span>
                      <span>&#8377;{(flightTotalPrice + parseFloat(this.props.markupAmount, 10)).toLocaleString()}</span>
                    </p>
                    <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-2`}>
                      <span>Agency Commision</span>
                      <span>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.commision, 10) + parseFloat(this.props.markupAmount, 10)).toLocaleString() :  Math.round(parseFloat(fareDetailsO.revisedFareDetails.commision, 10) + parseFloat(fareDetailsR.revisedFareDetails.commision, 10) + parseFloat(this.props.markupAmount, 10)).toLocaleString()}</span>
                    </p>
                    <p className={`u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-2`}>
                      <span>TDS</span>
                      <span>&#8377;{params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.tds, 10)).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.tds, 10) + parseFloat(fareDetailsR.revisedFareDetails.tds, 10)).toLocaleString()}</span>
                    </p>
                  </div>
                </div> ) : null }
              </React.Fragment> :
              <React.Fragment>
                <div className={`mb-5 mt-8`}>
                    <InputMaterial 
                        type='number'
                        label='Set Markup Amount' 
                        alignment='left' 
                        maxLength="10" 
                        value={this.props.markupInput} 
                        onChange={this.props.inputChangeHandler} 
                        name='markupInput' />
                </div>
                <div className="mb-3">
                  <ButtonProceed 
                      clicked={this.props.onSetMarkup}
                      isactive={ parseFloat(this.props.markupInput, 10) > 0 }>
                      SET MARKUP NOW
                  </ButtonProceed> 
                </div>
                <Button onClick={this.props.resetClicked} theme="OutlinePrimary" width="Block" type="MarkupLarge">RESET</Button>
              </React.Fragment>
            }
          </div>
        )}
          {
            !this.props.isSetMarkup ? <div>
            <div className={`u-flex justify-content-between align-items-center mb-4`}>
              <HeadingH3 size={26} weight="Medium" color="Dark">{this.props.isAgentProfit ? 'Net Fare' : 'Total Fare'}</HeadingH3>
              {isPathPay ? <h3 className={`u-textColorDark u-fontSize26 u-fontWeightMedium`}>&#8377; {Math.round(parseFloat(this.props.totalPrice, 10)).toLocaleString()}</h3> : <h3 className={`u-textColorDark u-fontSize26 u-fontWeightMedium`}>&#8377;{this.props.isAgentProfit ? params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.nf, 10) + totalAmount).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.nf, 10) + parseFloat(fareDetailsR.revisedFareDetails.nf) + totalAmount).toLocaleString() : params.get("isInt") === "true" ? Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf, 10) + parseFloat(this.props.markupAmount, 10) + totalAmount).toLocaleString() : Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf, 10) + parseFloat(fareDetailsR.revisedFareDetails.tf, 10) + parseFloat(this.props.markupAmount, 10) + totalAmount).toLocaleString()}</h3> }
            </div>
            <div style={{display: isPathPay ? 'none' : 'block'}}>
              <Media query="(min-width: 899px)">
                {matches => 
                  matches ? <ButtonProceed 
                    clicked={() => this.roundTripProceedHandler(totalAmount)}
                    isactive={ isPathDetails ? this.props.isContinueButtonActive : this.props.isPaymentButtonActive}>
                    {isPathDetails ? 'Continue' : 'Proceed To Pay'}
                  </ButtonProceed> 
                  : null 
                }
              </Media>
            </div>
          </div> : null
          }
        </div>
      </div>
    );
  }
  }
};

const mapStateToProps = state => {
  return {
    breakupExpanded: state.ui.breakupExpanded,
    isPaymentButtonActive: state.farePrice.isGstMandatory ? state.farePrice.isGstAdded: true,
    isContinueButtonActive: state.farePrice.paxCounter === 0 && state.farePrice.userParams.additionalContact.isEmailValid && state.farePrice.userParams.additionalContact.mobile !== '' && state.farePrice.userParams.additionalContact.mobileISD.trim() !== '' ? true : false,
    mobileFareBreakup: state.ui.mobileFareBreakup,
    superPnr: state.farePrice.generalData.superPnr,
    pid: state.farePrice.generalData.pricingId,
    searchId: state.farePrice.generalData.data.searchId,
    org: state.farePrice.generalData.data.org,
    dest: state.farePrice.generalData.data.dest,
    ftype: state.farePrice.generalData.data.ftype,
    changeFlightUrl: state.farePrice.generalData.changeFlightUrl,
    url: state.farePrice.generalData.sessionTimeoutData.pricingUrl,
    searchUrl: state.farePrice.generalData.sessionTimeoutData.searchUrl,
    ebs_accountId: state.farePrice.generalData.data.ebs_accountId,
    ebs_sessionId: state.farePrice.generalData.data.ebs_sessionId,
    passengers: state.farePrice.passengers,
    email: state.farePrice.userParams.additionalContact.email,
    mobile: state.farePrice.userParams.additionalContact.mobile,
    flightCode: state.flights.flightCode,
    paymentInfoLoading: state.payments.paymentInfoLoading,
    bookingDetailsLoading: state.payments.bookingDetailsLoading,
    totalPrice: state.payments.amountDetails ? state.payments.amountDetails.totalAmount : state.payments.totalPrice,
    convFee: state.payments.convFee,
    moProfileType: state.farePrice.generalData.data.moProfileType,
    userProfile: state.auth.userProfile,
    amountDetails: state.payments.amountDetails,
    isHff: state.farePrice.isHff
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onToggleFareBreakups: (val) => dispatch(uiActions.toggleFareBreakups(val)),
    onToggleMobileFareBreakup: () => dispatch(uiActions.toggleMobileFareBreakup()),
    onRemoveAddon: (label) => dispatch(farePriceActions.removeAddon(label)),
    onRemoveAddonFromFarePrice: (label) => dispatch(farePriceActions.removeAddonFromFarePrice(label)),
    onGetPaymentInfo: (paymentObject) => dispatch(paymentActions.getPaymentInfo(paymentObject))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(summaryExtended));



// WEBPACK FOOTER //
// ./src/components/Flight/FlightSummary/FlightSummary.js